import { Entidad } from "../../../data/Entidad";
import _L, { _HttpMsgV2 } from "../../../util/Labels";
import { UIUtilLang } from "../../util/Language";
import { NotificacionV2 } from "../NotificacionV2";
import { _ModalInfoDataList } from "./ModalInfoDataList";
import { IModalServiceIteratorBasicConfig } from "./ModalServiceIteratorBasic";
import { ModalThingsUtil as util } from "./Utils";

import CAccionPermiso = Entidad.CAccionPermiso

type IResponseItemData<Data> = util.IResponseItemData<Data>
type IModalThings = util.IModalThings

export type IModalServiceIteratorConfig<T> = Pick<IModalServiceIteratorBasicConfig<T>,
    "OnStepAProccess" | "OnStepAllProccess" | "OnEndProccess" | "OnEvalRetry" | "OnError_GetItemDataTag" | "AccionToHttpMessage" | "Action"
> & {
    TypeRequest?: Entidad.CTipoRequest,
    GeneralErrMessage?: string
}
/** Proceso de iteración de datos recursivo
*
* Finaliza cuando:
* * Todos los datos se procesan correctamente (res.Resultado > 0)
* * N datos resultan erroneos y no se Reintenta procesarlos
*
* dataProcess:
* * Al finalizar en implementación se puede ver dataProcess modificado
*/
export function _ModalServiceIterator<TData>(modalThings: IModalThings, dataProccess: IResponseItemData<TData>[], config: IModalServiceIteratorConfig<TData>, showNotif = true) {
    const actionHttp = config.AccionToHttpMessage || CAccionPermiso[config.Action];

    return new Promise<void>(async resolve2 => {
        const fnProccessData = async (dataToProccess: IResponseItemData<TData>[]) => {
            let itemsInProccess = dataToProccess.filter(d => (d.Resultado <= 0));
            modalThings.Modal._DeshabilitarBtns();
            modalThings.Progress.attr("oculto", false);

            if (config.OnStepAProccess) {
                for (let itemData of itemsInProccess) {
                    let itemResult = await config.OnStepAProccess(itemData.ItemData) as IResponseItemData<TData>;

                    for (let key in itemResult) {
                        itemData[key] = itemResult[key];
                    }
                    itemData.Datos = itemResult.Datos;
                    itemData.Mensaje = itemResult.Mensaje;
                    itemData.Resultado = itemResult.Resultado;
                    itemData.TipoRequest = itemResult.TipoRequest | config.TypeRequest;
                    itemData.EndPointName = itemResult.EndPointName;
                }
            } else if (config.OnStepAllProccess) {
                let itemsResult = await config.OnStepAllProccess(itemsInProccess.map(d => d.ItemData)) as IResponseItemData<TData>;

                itemsInProccess.forEach(itemData => {
                    for (let key in itemsResult) {
                        itemData[key] = itemsResult[key];
                    }
                    itemData.Datos = itemsResult.Datos;
                    itemData.Mensaje = itemsResult.Mensaje;
                    itemData.Resultado = itemsResult.Resultado;
                    itemData.TipoRequest = itemsResult.TipoRequest | config.TypeRequest;
                    itemData.EndPointName = itemsResult.EndPointName;
                })
                if (itemsInProccess.length == 0 && itemsResult) {
                    itemsInProccess.push(itemsResult)
                }
            }

            if (config.OnEndProccess) {
                config.OnEndProccess(itemsInProccess);
            }

            // -> Items fallidos
            let itemsFallidos = itemsInProccess.filter(d => (d.Resultado <= 0));
            modalThings.Progress.attr("oculto", true);

            if (itemsFallidos.length > 0) {
                const modalInfoList = _ModalInfoDataList<IResponseItemData<TData>>({
                    Title: _L("general.failresume"),
                    InfoText: config.GeneralErrMessage ? config.GeneralErrMessage : _L("general.notif_failarrayproccess"),
                    DataList: itemsFallidos,
                    Width: 280,
                    OnStepItemData: (container, itemData) => {
                        let html = config.OnError_GetItemDataTag(itemData.ItemData, container);
                        if (html) {
                            let messageHttp = itemData.Mensaje || _HttpMsgV2(itemData) || (actionHttp ? UIUtilLang._GetHTTPMessage(itemData, actionHttp) : "");
                            if (messageHttp) {
                                let lastIndexChar = messageHttp.length - 1;
                                if (messageHttp[lastIndexChar] == ".") {
                                    messageHttp = messageHttp.slice(0, lastIndexChar);
                                }
                                html += `<br><i style="color: var(--color_app_red1);">${messageHttp}.</i>`;
                            }
                            container.html(html);
                        }
                    },
                    OnClose: () => resolve2(), // -> Resignación: Acepta que hay errores y finaliza
                    OnAccept: () => resolve2(), // -> Resignación: Acepta que hay errores y finaliza
                })

                if (!config.OnEvalRetry || config.OnEvalRetry(itemsFallidos)) {
                    modalInfoList.BtnLeft
                        .classed("hide", false)
                        .text(_L("general.reintentar"))
                        .on("click", async () => {
                            // -> Terquedad: -_-
                            modalInfoList.Modal._Ocultar(false);
                            if (await fnProccessData(itemsFallidos)) {
                                resolve2();
                            }
                        })
                }
                return false;


            } else {
                if (showNotif) {
                    let messageHttp = UIUtilLang._GetHTTPMessage({ Resultado: 1, TipoRequest: config.TypeRequest, ...itemsInProccess[0] }, actionHttp);
                    NotificacionV2._Mostrar(messageHttp, "INFO");
                }
                return true;
            }
        }

        if (await fnProccessData(dataProccess)) {
            resolve2();
        }
    })

    // console.log("Proceso fin")
    // resolve1();
}